
import { useState } from "react"

const Circles = (props) => {
    const MediumGrey = { backgroundColor: "hsl(204, 4%, 22%)" }
    const Orange = { backgroundColor: "hsl(25, 97%, 53%)" };
    const LightGrey = { backgroundColor: "hsl(217, 12%, 63%)" };
    const imageCircle = props.image === true
    const [color,setcolor] = useState(MediumGrey)
    const number = props.number
    const handleclick = () => {
        props.setrating(number);
        setcolor(LightGrey)
    
    }
    return (
			<div
				className={`circle ${props.circlefor}`}
				onClick={handleclick}
				onMouseOver={() => {
					setcolor(Orange);
            }}
            onMouseLeave={() => {
                setcolor(MediumGrey)
            }}
				style={color}
			>
				{imageCircle && <img src="images/icon-star.svg" alt="star"></img>}
				<span>{number}</span>
			</div>
		);
}
 
export default Circles;